import { GenericFormItem } from 'skyone-lib/lib/GenericForm/interfaces';

export default [
  {
    gridXs: 12,
    label: 'GROUPS_PAGE.CLONE_GROUP_NAME_KEY',
    stateKey: 'name',
  },
  {
    gridXs: 12,
    label: 'DESCRIPTION_KEY',
    stateKey: 'description',
  },
] as GenericFormItem[];
